export default __webpack_public_path__ + "static/ico-uczestnicy-39a892642817807616fca3b1f9ca062a.svg";